import React from "react";
import { useNavigate } from "react-router-dom";
import "../CSS/HomePage.css";

const HomePage = () => {
  const navigate = useNavigate();

  const handleCreateClick = () => {
    navigate("/create"); // Corrected the typo
  };

  return (
    <div className="homepage-container">
      <div className="content">
        <h1 className="title">NBA Win Totals</h1>
        <p className="description">
          Discover and track the win totals of your favorite NBA teams. Stay
          updated with the latest standings and create your own league to
          compete with friends.
        </p>
        <p className="inspiration">
          Inspired by the Hoop Collective Podcast by Brian Windhorst himself
          (Legend).
        </p>
        <button className="cta-button" onClick={handleCreateClick}>
          Get Started
        </button>
      </div>
    </div>
  );
};

export default HomePage;
